import {createContext, PropsWithChildren, useCallback, useMemo, useRef, useState} from "react";
import {SimilarCost} from "../../../../api/Pricing";
import {EventEmitter} from "nate-react-api-helpers";

export type CostHelperObj = {
    product: number;
    productType: string;
    itemName: string | null;
}

export const CostHelperContext = createContext({
    show: (value: CostHelperObj, callback: SimilarCostCallback) => {
        return () => {}
    },
    value: new EventEmitter<CostHelperObj|null>(),
    onSelectPrice(value: SimilarCost) {

    }
});

type SimilarCostCallback = (value: SimilarCost) => void;

export function CostHelperProvider(props: PropsWithChildren<{}>) {
    const [value] = useState(new EventEmitter<CostHelperObj|null>());
    const onSelectPriceRef = useRef<SimilarCostCallback|null>(null);

    const show = useCallback((newValue: CostHelperObj, onSelectPrice: SimilarCostCallback) => {
        value.emit(newValue);
        onSelectPriceRef.current = onSelectPrice;

        return () => {
            value.emit(null);
        }
    }, [value])

    const onSelectPrice = useCallback((value: SimilarCost) => {
        console.log("onSelectPrice", value, onSelectPriceRef.current)
        if(!onSelectPriceRef.current) return;
        onSelectPriceRef.current(value);
    }, [])

    const ctx = useMemo(() => {
        return {
            show: show,
            value: value,
            onSelectPrice: onSelectPrice,
        }
    }, [show, value, onSelectPrice])

    return (
        <CostHelperContext.Provider value={ctx}>
            {props.children}
        </CostHelperContext.Provider>
    )
}